import { isAnalyticsEnabled } from "./isAnalyticsEnabled";
import { installAxiosAnalytics } from "./axiosSetup";
import { installFetchAnalytics } from "./autoTrack";
import { trackEvent, getSessionId } from "./umami";

const UMAMI_WEBSITE_ID = "fb61db14-54a2-4a97-ad55-c85eeb0a95ea";
const UMAMI_SCRIPT_SRC = "https://cloud.umami.is/script.js";

function loadUmamiScript() {
  if (typeof document === "undefined") return;
  if (document.querySelector(`script[data-website-id="${UMAMI_WEBSITE_ID}"]`))
    return;
  const s = document.createElement("script");
  s.defer = true;
  s.src = UMAMI_SCRIPT_SRC;
  s.setAttribute("data-website-id", UMAMI_WEBSITE_ID);
  document.head.appendChild(s);
}

const CLICK_FLAG = "__testsphereUmamiClickInstalled";

function installClickTracking() {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (window[CLICK_FLAG]) return;
  window[CLICK_FLAG] = true;

  document.addEventListener(
    "click",
    (event) => {
      const target = event.target?.closest?.(
        'button, [role="button"], a[href], [data-track-label]',
      );
      if (!target) return;

      let label = "";
      if (target.hasAttribute?.("data-track-label")) {
        label = String(target.getAttribute("data-track-label") || "").trim();
      }
      if (!label) {
        label = (target.textContent || "").replace(/\s+/g, " ").trim();
      }
      if (!label) return;

      const page =
        typeof window.location !== "undefined" ? window.location.pathname : "";

      trackEvent("ui.click", {
        label: label.slice(0, 200),
        page,
      });
    },
    true,
  );
}

/**
 * Runs at import time — must be the first import in index.js so axios.create is patched
 * before any service module loads (production only).
 */
if (typeof window !== "undefined" && isAnalyticsEnabled()) {
  loadUmamiScript();
  getSessionId();
  installFetchAnalytics();
  installAxiosAnalytics();
  installClickTracking();
}
